import { render, staticRenderFns } from "./ApprovalDetail.vue?vue&type=template&id=7243f895&scoped=true"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetail.vue?vue&type=style&index=0&id=7243f895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7243f895",
  null
  
)

export default component.exports